import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import withStyles from '@material-ui/core/styles/withStyles';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import {
  allPass, propEq, ifElse, isNil, map, find, prop, path, equals, any, propOr,
} from 'ramda';
import RoleHeader from './TeamRoleHeader';
import Permissions from './Permissions';

const style = theme => ({
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
  },
  roleNameDivider: {
    marginTop: '1rem',
  },
});

const findPermission = (resource, action) => find(allPass([propEq('action', action), propEq('resource', resource)]));
const isActionEnabled = (action, permissions) => ifElse(isNil, () => ({ enabled: false, ...action }), () => ({ enabled: true, ...action }))(
  permissions,
);
const mapActionStates = (permissions, template) => map((mapping) => {
  const mappedActions = map(action => isActionEnabled(action, findPermission(mapping.resource, action.action)(permissions)))(mapping.actions);

  return {
    ...mapping,
    actions: mappedActions,
  };
})(template);

const getRoleIdentifier = path(['role', 'roleIdentifier']);
const getRoleDisplayName = prop('displayName');
const getRoleTeam = prop('team');

class RoleView extends Component {
  state = {
    displayName: '',
    team: '',
  };

  static getDerivedStateFromProps(props, state) {
    const newRoleIdentifier = getRoleIdentifier(props);
    if (!equals(newRoleIdentifier, state.prevRoleIdentifier)) {
      return {
        prevRoleIdentifier: newRoleIdentifier,
        displayName: getRoleDisplayName(newRoleIdentifier),
        team: getRoleTeam(newRoleIdentifier),
      };
    }
    return null;
  }

  onHeaderChange = (type, value) => {
    switch (type) {
      case 'name':
        this.setState({ displayName: value });
        break;

      case 'id':
        this.setState({ team: value });
        break;

      default:
        break;
    }
  };

  render() {
    const {
      title,
      role,
      template,
      classes,
      isLoading,
      readOnly,
      onPermissionChange,
      onRoleIdentifierChange,
      history,
      currentTeamRole,
    } = this.props;
    const { roleIdentifier, permissions } = role;
    const { name } = roleIdentifier;
    const actualTeam = roleIdentifier.team;
    const actualDisplayName = roleIdentifier.displayName;
    const { displayName, team } = this.state;

    const mapAction = mapActionStates(permissions, template);

    const newMap = mapActionStates(currentTeamRole.permissions, template);


    newMap.map((resource, idx) => {
      if (any(propOr(false, 'enabled'))(resource.actions)) {
        mapAction[idx].permission = true;
        resource.actions.map((action, ind) => {
          (action.enabled ? mapAction[idx].actions[ind].permission = true : mapAction[idx].actions[ind].permission = false);
        });
      }
    });

    return (
      <commonComponents.Panel
        title={`${title}: ${displayName}`}
        avatar={(
          <Avatar>
            <Lock />
          </Avatar>
)}
      >
        {!isLoading && (
          <div>
            <RoleHeader
              name={displayName}
              team={team}
              readOnly={readOnly}
              onChange={this.onHeaderChange}
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.gradientButton}
              onClick={() => onRoleIdentifierChange(name, team)}
              disabled={readOnly}
            >
              Update Role Name
            </Button>
            <Divider className={classes.roleNameDivider} />
          </div>
        )}
        <Permissions
          template={mapAction}
          onChange={onPermissionChange({ name, team: actualTeam, displayName: actualDisplayName })}
          isLoading={isLoading}
          readOnly={readOnly}
        />
        <Button
          variant="contained"
          color="primary"
          className={classes.gradientButton}
          onClick={() => {
            history.goBack();
          }}
        >
          Back
        </Button>
      </commonComponents.Panel>
    );
  }
}

RoleView.propTypes = {
  title: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired,
  template: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onPermissionChange: PropTypes.func.isRequired,
  onRoleIdentifierChange: PropTypes.func.isRequired,
};

export default withStyles(style)(RoleView);
